module.exports = __webpack_public_path__ + "img/ZWF_Marti_Natalia.4630ab86.jpg";